<template lang="pug">
#bloco-informacao
    .bloco-informacao__interno
        span
            slot(name='icone')
        span.bloco-informacao__interno-texto {{ titulo }}
    span.bloco-informacao__interno-numero {{ numero }} {{ sigla }}
</template>

<script>
export default {
    name: 'EmpresaBlocoInformacao',
    props: {
        titulo: {
            type: String,
            default: () => ''
        },
        numero: {
            type: [String, Number],
            default: () => ''
        },
        sigla: {
            type: String,
            default: () => ''
        }
    }
};
</script>

<style lang="scss">
#bloco-informacao {
    flex-grow: 1;
    min-width: 20%;
    background: var(--white);
    border-radius: 3px;
    display: flex;
    justify-content: space-between;
    min-height: 89px;
    align-items: center;
    color: var(--primary);
    flex-wrap: wrap;
    box-shadow: 0px 0px 2px 0px var(--block-shadow);
    padding: 17px 10px;

    .bloco-informacao__interno {
        display: flex;
        justify-content: center;
        align-items: center;

        .lyra-icon::before {
            content: '';
            width: 28px !important;
            height: 25px !important;
            background-color: var(--primary) !important;
        }

        .mdi::before {
            font-size: 26px !important;
            color: var(--primary) !important;
        }
    }

    .bloco-informacao__interno-numero {
        font-size: 17px;
        font-weight: 600;
    }

    span {
        padding: 3px;

        &.bloco-informacao__interno-texto {
            max-width: 156px;
            font-weight: 600;
        }
    }
}
@media only screen and (max-width: 1334px) {
    #bloco-informacao {
        min-width: 48% !important;
        flex-grow: 0;
    }
}
</style>
